/**
 * Returns a random number between min (inclusive) and max (exclusive)
 */
export const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min) + min);
